import { Scoreboard } from "src/utils/scoreboard";

// Bridges the live scoreboard (computed inside React on the live page) to the Cast sender (which
// forwards it to a custom Cast receiver to draw on the TV). The sender lives inside the generic
// VideoJS/CastControls tree and has no idea about scoreboards, so rather than prop-drill through
// the player we use a module-level singleton — the same pattern as auth-token.ts, which hands the
// Auth0 token to the RTK base query that also runs outside the React tree.

type Sender = (sb: Scoreboard | null) => void;

let sender: Sender | null = null;
let latest: Scoreboard | null = null;

// The Cast sender registers while a custom-receiver session is connected, and deregisters (null)
// on disconnect. Registering immediately flushes the latest board so the TV catches up at connect.
export function registerCastScoreboardSender(fn: Sender | null): void {
  sender = fn;
  if (fn) fn(latest);
}

// The live overlay publishes here on every scoreboard change; forwarded to the TV if casting.
export function publishScoreboard(sb: Scoreboard | null): void {
  latest = sb;
  sender?.(sb);
}
